import service from './axios';


export const me = (phoneNumber) => {
    return service.get('/user/me');
};

// 更新用户信息
export const sendLoginCode = (phoneNumber, captchaVerifyParam) => {
    return service.post('/login/send_code', {
        phone_number: phoneNumber,
        captcha_verify: captchaVerifyParam

    }
    );
};

export const verifyLoginCode = (phoneNumber, code, openid) => {
    return service.post('/login/verify_code', {
        phone_number: phoneNumber,
        code: code,
        openid: openid,

    }
    );
};

export const switchPriceCurrency = (priceCurrency) => {
    return service.post('/user/switch_price_currency', {
        price_currency: priceCurrency

    }
    );
};


export const sendPhoneAuthIdentitySMS = (captchaVerifyParam) => {
    return service.post('/user/send_phone_auth_identity_sms', {
        captcha_verify: captchaVerifyParam
    }
    );
};


export const verifyPhoneAuthIdentityCode = (code) => {
    return service.post('/user/verify_phone_auth_identity_sms', {
        code: code
    }
    );
};


export const sendChangePhoneNumberSMS = (new_phone_number, captchaVerifyParam) => {
    return service.post('/user/send_change_phone_number_sms', {
        new_phone_number: new_phone_number,
        captcha_verify: captchaVerifyParam
    }
    );
};


export const verifyChangePhoneNumberCode = (new_phone_number, code) => {
    return service.post('/user/verify_change_phone_number_sms', {
        new_phone_number: new_phone_number,
        code: code,
    }
    );
};


export const unbindWechat = () => {
    return service.post('/user/unbind_wechat');
};


export const getPushSettings = (bot_type) => {
    return service.get('/user/get_push_settings');
};


export const updatePushSettings = (data) => {
    return service.post('/user/update_push_settings', data
    );
};